import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro'
import './shared-book-page.scss'
import './shared-book-entry-form.scss'
import SharedBook from './shared-book'

class SharedBookPage extends Component {
  constructor() {
    super()
    this.state = {
      showBook: false,
      enteredPassword: ''
    }
  }

  checkPassword = function (event) {
    const password = this.props.sharedBook.password
    this.setState({ enteredPassword: event.target.value })

    if (password === event.target.value) {
      this.setState({ showBook: true })
    }
  }

  render() {
    const { sharedBook } = this.props

    return (
      <>
        {this.state.showBook && <SharedBook sharedBook={sharedBook} />}
        {!this.state.showBook && <SharedBookEntryForm value={this.state.enteredPassword} checkPassword={this.checkPassword.bind(this)} />}

        <div className="sg_sharedBookPage__footer">
          <div><a href="http://www.startupguide.com/"><img className="sg_sharedBookPage__logoLink" src="https://uploads-ssl.webflow.com/5fa9a143aebd091f1932bddd/5fa9d5a7231e76a9743e17b6_sg-logo.svg" /></a></div>
          <p className="sg_sharedBookPage__copyright"><a href="http://www.startupguide.com/">&copy; Startup Guide 2022. All rights reserved.</a></p>
        </div>
      </>
    )
  }
}

class SharedBookEntryForm extends Component {
  constructor() {
    super()
  }

  render() {
    const { checkPassword, value } = this.props
    return (
      <div className="sg_sharedBookEntryForm">
        <div className="sg_sharedBookEntryForm__box">
          <p>This link contains confidential or legally privileged material. You were granted access to a copy of the book because you are a partner or a contributor.</p>
          <p><strong>Sharing this link or giving access to others is unauthorized.</strong></p>
          <p><strong>‍It is not permitted to share this link publicly either in print or digital form.</strong></p>
          <p>Please enter the password:<input type="text" maxlength="50" className="sg_sharedBookEntryForm__password" autoFocus={true} value={value} onChange={(event) => checkPassword(event)} /></p>
        </div>
      </div>
    )
  }
}

export default createFragmentContainer(
  SharedBookPage,
  graphql`
        fragment sharedBookPage_sharedBook on SharedBook {
            slug
            title
            coverImage
            coverImageAlt
            downloadSize
            downloadType
            downloadURL
            purchaseURL
            contactEmail
            contactSubject
            password
        }
    `
)
